import { HeaderNavTab } from '@bessemercws/components';

interface GetHeaderNavTabsParams {
  isTabDisabled: boolean;
  additionalServices: HeaderNavTab[];
  buildAdditionalServicesTab: (services: any, disabled: boolean) => HeaderNavTab;
  userProfileTypeLinkConfig?: { links: HeaderNavTab[], homeLink: string }
  isUnknownUserProfileType?: boolean;
}

export const getHeaderNavTabs = ({
  isTabDisabled,
  additionalServices,
  buildAdditionalServicesTab,
  userProfileTypeLinkConfig,
  isUnknownUserProfileType,
}: GetHeaderNavTabsParams): HeaderNavTab[] => {
  if (userProfileTypeLinkConfig) {
    return userProfileTypeLinkConfig.links;
  }

  return [
    {
      label: 'Accounts',
      to: '', // index
      skip: isUnknownUserProfileType,
    },
    {
      label: 'Documents',
      to: 'documents',
      disabled: isTabDisabled,
      skip: isUnknownUserProfileType,
    },
    buildAdditionalServicesTab(additionalServices, isTabDisabled),
    {
      label: 'Insights',
      to: 'insights',
      skip: isUnknownUserProfileType,
    },
  ];
};
